<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive" />
  </div>
</template>
<script>
import systemConfig from '@/config' // 导入系统配置
export default {
  data() {
    return {
      systemConfig
    }
  },
  mounted() {},
  methods: {},
  beforeDestroy() {}
}
</script>
<style lang="scss">
body {
  width: 100%;
  height: 100%;
  margin: 0;
  background: #f2f2f2;
}
#app {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

ul,
li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
body::-webkit-scrollbar {
  display: none;
}
</style>
